import { useRouter } from 'next/router';
import { useAuth } from '../../hooks/useAuth';
import { memberToolsRoutes } from '@/routes/memberTools';
import { useEffect, useState } from 'react';
import { getPrevRoute, setPrevRoute } from '@/utils/prevRoute';

export function StrictlyPublicRoute({ children }) {
  const { status, authStatuses } = useAuth();
  const router = useRouter();
  const [previousRoute, setPreviousRoute] = useState('');
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const localStoragePrevRoute = getPrevRoute();
    if (localStoragePrevRoute) {
      setPreviousRoute(localStoragePrevRoute);
    }
  }, []);

  useEffect(() => {
    if (status === authStatuses.SIGNED_OUT || status === authStatuses.PENDING) {
      setIsLoggedOut(true);
    } else {
      router.push(previousRoute || memberToolsRoutes.memberTools.path);
      setPrevRoute('');
      return null;
    }
  }, [router, status, authStatuses]);

  if (isLoggedOut) {
    return children;
  } else {
    return null;
  }
}
